export default __webpack_public_path__ + "static/media/node-run.cd75ff25.png";